(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[957],{

/***/ 40081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[company]",
      function () {
        return __webpack_require__(8483);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 43228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25575);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable react/no-array-index-key */ 


function Pagination(param) {
    var items = param.items;
    var pages = items || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "mb-10 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
            className: "flex space-x-4 rounded-md bg-white px-6 shadow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        className: "h-5 w-5 flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    })
                }),
                pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            "flex last-of-type:hidden md:last-of-type:flex": pages.length > 1
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "h-full w-6 flex-shrink-0 text-gray-200",
                                    viewBox: "0 0 24 44",
                                    preserveAspectRatio: "none",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: page.linkAs,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                        "aria-current": page.current ? "page" : undefined,
                                        children: page.name
                                    })
                                })
                            ]
                        })
                    }, "breadcrumb-".concat(page.name, "-").concat(index));
                })
            ]
        })
    });
};


/***/ }),

/***/ 13693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (ForwardRef);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/card.module.css
var card_module = __webpack_require__(49969);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/global/card.jsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 




function Card(_param) {
    var props = _extends({}, _param);
    var link = props.link, image = props.image, title = props.title, type = props.type, additional = props.additional, location = props.location;
    var user = (0,react.useContext)(app/* default */.Z).user;
    // hack
    var isRestroom = title.toLowerCase().includes("restroom");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group relative block",
            children: [
                (user === null || user === void 0 ? void 0 : user.CanAccessAdmin) && (location === null || location === void 0 ? void 0 : location.Latitude) && (location === null || location === void 0 ? void 0 : location.Longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 z-10 rounded-tr rounded-bl bg-blue-500 p-2",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_GlobeAltIcon, {
                        className: "h-4 w-4 fill-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "aspect-w-16 aspect-h-9 overflow-hidden rounded-lg group-hover:opacity-75",
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                        srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                        alt: image.alternativeText ? image.alternativeText : title,
                        className: "h-full w-full object-cover object-center"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full w-full bg-gray-200 object-cover object-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center ".concat((card_module_default()).contents),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "flex",
                                src: "/placeholder-".concat(isRestroom ? "restroom" : type, ".svg"),
                                alt: title
                            })
                        })
                    })
                }),
                additional && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 text-sm text-gray-500",
                    children: additional
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-base font-semibold text-gray-900 ".concat(!additional ? "mt-3" : ""),
                    children: title
                })
            ]
        })
    });
};


/***/ }),

/***/ 36551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);


function Throw404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
        statusCode: 404
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Throw404);


/***/ }),

/***/ 8483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Company; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./components/throw404.jsx
var throw404 = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/global/card.jsx + 1 modules
var card = __webpack_require__(13693);
// EXTERNAL MODULE: ./components/global/breadcrumbs.jsx
var global_breadcrumbs = __webpack_require__(43228);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/ParkCard.js
var ParkCard = __webpack_require__(59147);
;// CONCATENATED MODULE: ./queries/company.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  query Company($slug: String!) {\n    companies(where: { Slug: $slug }) {\n      Name\n      Slug\n      id\n      AlternativeNames {\n        Name\n      }\n      Resorts {\n        id\n        Name\n        Slug\n      }\n      Parks {\n        ...ParkCard\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var COMPANY_QUERY = (0,graphql_request_dist.gql)(_templateObject(), ParkCard/* default */.Z);
/* harmony default export */ var queries_company = (COMPANY_QUERY);

;// CONCATENATED MODULE: ./components/companies/company-detail.jsx








function CompanyDetails() {
    var ref;
    var router = (0,next_router.useRouter)();
    var variables = {
        slug: router.query.company
    };
    var ref1 = (0,dist/* default */.ZP)([
        queries_company,
        variables
    ]), data = ref1.data, error = ref1.error;
    if (error) {
        console.log(error);
    }
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.companies) || !(data === null || data === void 0 ? void 0 : (ref = data.companies) === null || ref === void 0 ? void 0 : ref.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(throw404/* default */.Z, {});
    }
    var company = data.companies[0];
    var breadcrumbs = [];
    breadcrumbs.push({
        name: company.Name,
        link: "/company/[company]",
        linkAs: "/company/".concat(company.Slug)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        company.Name,
                        " | Open Coaster"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_breadcrumbs/* default */.Z, {
                        items: breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-10 font-serif text-5xl text-gray-800",
                        children: company.Name
                    }),
                    Array.isArray(company.Resorts) && company.Resorts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-3 font-serif text-3xl text-gray-800",
                                children: company.Resorts.length > 1 ? "Resorts" : "Resort"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 grid grid-cols-2 gap-8 md:grid-cols-2 lg:grid-cols-4",
                                children: company.Resorts.map(function(resort) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                        link: "/resort/".concat(resort.Slug),
                                        title: resort.Name,
                                        image: resort.MainPhoto,
                                        type: "resort"
                                    }, resort.id);
                                })
                            })
                        ]
                    }),
                    Array.isArray(company.Parks) && company.Parks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-3 font-serif text-3xl text-gray-800",
                                children: company.Parks.length > 1 ? "Parks" : "Park"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4",
                                children: company.Parks.map(function(park) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
                                        link: "/park/".concat(park.Slug),
                                        title: park.Name,
                                        image: park.MainPhoto,
                                        type: "park",
                                        isTempClosed: park.IsTempClosed
                                    }, park.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/company/[company].jsx



var __N_SSG = true;
function Company(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config/* default */.Z, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDetails, {})
    });
};


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MainPhoto on UploadFile {\n    caption\n    alternativeText\n    hash\n    ext\n    width\n    height\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainPhoto = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (MainPhoto);


/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20519);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  fragment ParkCard on Parks {\n    id\n    Name\n    Slug\n    CurrentlyOperating\n    IsTempClosed\n    MainPhoto {\n      ...MainPhoto\n    }\n    Location {\n      Latitude\n      Longitude\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ParkCard = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject(), queries_fragments_MainPhoto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (ParkCard);


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 49969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contents":"card_contents__EHihQ"};

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ }),

/***/ 25575:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function HomeIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(HomeIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,774,888,179], function() { return __webpack_exec__(40081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);